import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import ChooseChild from './child';
import MoveLessonsComponent from './MoveLessons';
import Navigation from './Navigation';
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';
import { searchChildren } from './actions';
import WeeklyProgramCalendar from '../weeklyPrograms/calendar';
import { loadLessonDates } from '../weeklyPrograms/actions';
import { loadWeeklyProgram } from './actions';
import { moveLessons, loadChildLessons } from './actions';
import utils from '../../common/services/utils';
import { Alert, Panel, Row, Col, Button } from 'react-bootstrap';
import { selector as moveLessonsSettingsFormSelector } from './SettingsForm';

class MoveLessons extends Component {

	constructor(props) {
		super(props);
		this.handleGoToStep = this.handleGoToStep.bind(this);
		this.handleFilterChildren = this.handleFilterChildren.bind(this);
		this.handleResetChildrenFilter = this.handleResetChildrenFilter.bind(this);
		this.handleSelectChild = this.handleSelectChild.bind(this);
		this.handleSelectWeeklyProgram = this.handleSelectWeeklyProgram.bind(this);
		this.handleSourceWeeklyProgramChange = this.handleSourceWeeklyProgramChange.bind(this);
		this.handleLessonTypeChange = this.handleLessonTypeChange.bind(this);
		this.handleGoToPreviousStep = this.handleGoToPreviousStep.bind(this);
		this.handleMoveLessonsSubmit = this.handleMoveLessonsSubmit.bind(this);
		this.handleChildListEvent = this.handleChildListEvent.bind(this);
		this.loadChildren = this.loadChildren.bind(this);
		this.handleInitializeChildrenFilter = this.handleInitializeChildrenFilter.bind(this);
		this.initializeWeeklyProgramFilter = this.initializeWeeklyProgramFilter.bind(this);
		this.openedFromRegister = false;
		this.state = {
			currentStep: 1,
			childId: undefined,
			targetWeeklyProgramId: undefined,
			sourcePaymentId: undefined,
			lessonType: 1,
			success: false
		};
	}

	// opened from the Lesson Attendance register: the child and the class they are currently in are
	// already known, so skip the child search and start on the target class step
	componentDidMount() {
		const { location, loadChildLessons, loadWeeklyProgram } = this.props;
		const { childId, parentId, sourcePaymentId, centerId, termId } = queryString.parse((location && location.search) || '');

		if (!childId) {
			return;
		}

		// the wizard shows child.fullName / parent.fullName; load through the same search step 1 uses,
		// because api/children/{id} does not include the parent and would map it to null.
		// the page arguments are required - without them the reducer computes pages as NaN
		this.loadChildren({ filter: { parentId }, pageNumber: 1, pageSize: 10 });
		loadChildLessons({ childId, isPaid: 'true' });

		if (centerId && termId) {
			// seeds filters.moveLessonsWeeklyProgram, which the calendar reads when it mounts on the next render
			loadWeeklyProgram({ centerId, termId });
		}

		this.openedFromRegister = true;
		this.updateState({
			childId: Number(childId),
			sourcePaymentId: sourcePaymentId ? Number(sourcePaymentId) : undefined,
			currentStep: 2
		});
	}

	initializeWeeklyProgramFilter(form, data, fields) {
		return this.props.initialize(form, data, fields);
	}

	loadChildren({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		const { searchChildren } = this.props;
		searchChildren({ ...filter, isDeleted: false, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleSourceWeeklyProgramChange(event, value) {
		this.updateState({ sourcePaymentId: value });
	}

	handleLessonTypeChange(event, value) {
		this.updateState({ lessonType: value });
	}

	handleFilterChildren(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.childrenPagignation;
		this.loadChildren({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleResetChildrenFilter() {
		this.handleFilterChildren({});
	}

	handleSelectChild(child) {
		this.updateState({ childId: child.id, currentStep: this.nextStep() });
		const { loadChildLessons } = this.props;
		loadChildLessons({ childId: child.id, isPaid: 'true' });

	}

	handleSelectWeeklyProgram(day, weeklyProgramItem) {
		const { loadLessonDates } = this.props;
		loadLessonDates(weeklyProgramItem.id);
		//	loadChildLessons({ childId });
		this.updateState({ targetWeeklyProgramId: weeklyProgramItem.id, currentStep: this.nextStep() });
	}

	handleGoToPreviousStep() {
		const { currentStep } = this.state;
		let clearFields;
		if (currentStep == 2) {
			clearFields = { targetWeeklyProgramId: undefined };

			if (this.openedFromRegister) {
				// the register loaded only this parent's children - the child search must offer all of them
				this.openedFromRegister = false;
				this.handleResetChildrenFilter();
				this.props.initializeChildrenFilter({});
			}
		} else if (currentStep == 3) {
			clearFields = { sourcePaymentId: undefined, lessonType: 1 };
		}

		this.updateState({ currentStep: this.previousStep(), ...clearFields });
	}

	handleMoveLessonsSubmit(values) {
		const { childId, targetWeeklyProgramId } = this.state;
		const { sourceLessonDate, sourcePaymentId, targetLessonDate } = values;
		const { moveLessons, t } = this.props;
		moveLessons({
			childId,
			fromPaymentId: sourcePaymentId,
			toWeeklyProgramId: targetWeeklyProgramId,
			fromDate: sourceLessonDate,
			startDate: targetLessonDate
		}, () => this.updateState({ success: true }));
	}

	nextStep() {
		return this.state.currentStep + 1;
	}

	previousStep() {
		return this.state.currentStep - 1;
	}

	handleGoToStep(step) {
		this.updateState({ currentStep: step });
	}

	handleChildListEvent(listPagination) {
		const { filter } = this.props.childrenPagignation;
		this.loadChildren({ filter, ...listPagination });
	}

	updateState(nextState) {
		const state = this.state;
		this.setState({ state, ...nextState });
	}

	handleInitializeChildrenFilter(filter) {
		this.props.initializeChildrenFilter(filter);
	}

	render() {
		const {
			t, childrenPagignation, children, currentUser, weeklyPrograms, centers,
			terms, loadWeeklyProgram, lessonDates,
			childLessons, lessonTypes, lessonsFilter, allChildren, utcOffset,
			weeklyProgramFilter, timetableViewType,
			moveLessonsFormValues
		} = this.props;
		const { currentStep, targetWeeklyProgramId, sourcePaymentId, childId, lessonType, success } = this.state;

		if (success) {
			return (<div>
				<Alert bsStyle='success'>{t('MoveLessons_Success')}</Alert>
				<Button className='btn btn-default mt-0' onClick={() => this.setState({
					currentStep: 1,
					childId: undefined,
					targetWeeklyProgramId: undefined,
					sourcePaymentId: undefined,
					lessonType: 1,
					success: false
				})} > {t('MoveLessons_NewMoving')} </Button>
			</div>);

		}

		//Get current weekly programs
		const { ids } = lessonsFilter;
		let currentProgramRows = [];
		if (ids.length > 0) {
			const lessonFilter = (l) => {
				return l && l.child && l.child.id == childId &&
					// For nomral/paid lessons extract only future dates. For trial lessons extract not attended dates.
					((l.lessonType == 1 && utils.isUpcomingDate(l.start, utcOffset)) || (l.lessonType == 2 && !l.isAttended));
			};

			const lessonsForChild = ids.map(id => childLessons[id]).filter(lesson => lessonFilter(lesson));

			const currentWeeklyPrograms = utils.toObject(lessonsForChild.map(lesson => lesson.weeklyProgramItem), 'id');


			if (currentWeeklyPrograms && Object.keys(currentWeeklyPrograms).length) {
				currentProgramRows = Object.values(currentWeeklyPrograms).map((program, index) => (
					<p key={index}>
						{program.name}
					</p>)
				);
			}
		}
		let child = allChildren[childId];

		return (
			<div>
				<Navigation
					currentStep={currentStep}
					onGoToStep={this.handleGoToStep}
					onPreviousStep={this.handleGoToPreviousStep}
					t={t}
				/>
				{currentStep == 1 &&
					<ChooseChild
						t={t}
						pagination={childrenPagignation}
						data={children}
						onFilterChildren={this.handleFilterChildren}
						onResetChildFilter={this.handleResetChildrenFilter}
						onSelectChild={this.handleSelectChild}
						onChildListEvent={this.handleChildListEvent}
						onLoadChildren={this.loadChildren}
						onInitializeFilter={this.handleInitializeChildrenFilter}
					/>
				}
				{currentStep == 2 &&
					<div>
						<Panel>
							<Panel.Body>
								{child && <Row>
									<Col sm={6}>
										<p><b>{t('MoveLessons_Child')} </b></p>
										<p>{child.fullName}</p>
									</Col>
									<Col sm={6}>
										<p><b>{t('MoveLessons_Parent')} </b></p>
										<p>{child.parent && child.parent.fullName}</p>
									</Col>
								</Row>}
								{currentProgramRows.length > 0 &&
									<Row>
										<Col sm={12}>
											<p><b>{t('MoveLessons_CurrentPrograms')}</b></p>
											{currentProgramRows}
										</Col>
									</Row>}
							</Panel.Body>
						</Panel>
						<WeeklyProgramCalendar
							kindergarten={false}
							onWeeklyProgramItemClick={this.handleSelectWeeklyProgram}
							weeklyPrograms={weeklyPrograms}
							currentUser={currentUser}
							centers={centers}
							terms={terms}
							loadWeeklyProgram={loadWeeklyProgram}
							weeklyProgramFilter={weeklyProgramFilter}
							initializeFilter={this.initializeWeeklyProgramFilter}
							filterHeading={t('MoveLesson_SelectCenterTermHeader')}
							showAvailabilityColor
							timetableViewType={timetableViewType}
						/>
					</div>
				}
				{currentStep == 3 &&
					<MoveLessonsComponent
						lessonDates={lessonDates}
						targetWeeklyProgram={weeklyPrograms[targetWeeklyProgramId]}
						childLessons={childLessons}
						sourcePaymentId={sourcePaymentId}
						child={allChildren[childId]}
						onSourceWeeklyProgramChange={this.handleSourceWeeklyProgramChange}
						onLessonTypeChange={this.handleLessonTypeChange}
						lessonTypes={lessonTypes}
						lessonType={lessonType}
						onMoveLessonsSubmit={this.handleMoveLessonsSubmit}
						lessonsFilter={lessonsFilter}
						utcOffset={utcOffset}
						{...moveLessonsFormValues}
					/>}
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { children, weeklyPrograms, centers, terms, lessonDates, childLessons },
		filters: { moveLessonsChildLessonsByChild, moveLessonsWeeklyProgram },
		auth: { currentUser },
		lookups: { lessonTypes },
		configuration: { franchisor },
	} = state;

	const moveLessonsWeeklyProgramFilter = moveLessonsWeeklyProgram.all || { ids: [], filter: {}, loading: false };
	const childrenPagignation = pagination.moveLessonsChildren.all || { ids: [], pageNumber: 1, pageSize: 10 };
	const lessonsFilter = moveLessonsChildLessonsByChild.all || { ids: [] };

	const onlineCenters = utils.filter(centers, center => center.isOnline && center.territory && center.territory.isOnline);
	const activeWeeklyPrograms = utils.filter(weeklyPrograms, p => !p.isDeleted);

	return {
		currentUser,
		allChildren: children,
		children: childrenPagignation.ids.map(id => children[id]),
		childrenPagignation,
		weeklyPrograms: activeWeeklyPrograms,
		centers: onlineCenters,
		terms: terms,
		lessonDates,
		childLessons,
		lessonTypes,
		lessonsFilter,
		utcOffset: franchisor.utcOffsetHours,
		timetableViewType: franchisor.timetableViewType,
		weeklyProgramFilter: moveLessonsWeeklyProgramFilter,
		moveLessonsFormValues: moveLessonsSettingsFormSelector(state, 'sourceLessonDate', 'targetLessonDate')
	};
};

const mapDispatchToProps = {
	searchChildren,
	loadLessonDates,
	loadChildLessons,
	moveLessons,
	initializeChildrenFilter: (data, fields) => initialize('moveLessonsChildFilter', data, fields),
	loadWeeklyProgram,
	initialize
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MoveLessons));